// The seam between the shared offline core and each app's storage. Pure: the
// web adapter wraps Cache Storage, a native one will wrap the file system.

import type { AudioAsset } from "@aybuben/core/content/assets.ts";

/** A recording's verified bytes and the MIME type they were served as. */
export interface AudioBody {
	readonly bytes: Uint8Array<ArrayBuffer>;
	readonly type: string;
}

export interface AudioStore {
	/** File id plus full digest, so a re-recorded file is a new key, never a stale hit. */
	key(a: AudioAsset): string;
	keys(): Promise<Set<string>>;
	/** False when the bytes were not retained: quota, blocked storage. */
	put(a: AudioAsset, body: AudioBody): Promise<boolean>;
	delete(key: string): Promise<void>;
}

/**
 * Why a download failed. `network`: the connection. `server`: a 429 or 5xx,
 * the server is struggling, so stop and come back later. `http` and
 * `integrity`: this one file, so skip it and carry on.
 */
export type DownloadFailure = "network" | "server" | "http" | "integrity";

export class DownloadError extends Error {
	constructor(
		readonly kind: DownloadFailure,
		message: string,
	) {
		super(message);
	}
}

export type Download = (a: AudioAsset) => Promise<AudioBody>;
